export { TypeFilledSize2XlColorGray } from "./TypeFilledSize2XlColorGray";
